export default __webpack_public_path__ + "static/faq2-e37d20af75d195fb61b6b7d10c8b2651.png";